module.exports = __webpack_public_path__ + "dad9e0cbe03564796f799703d56c8a50.pdf";